export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14514.481bbe3a.jpg";